export const ONBOARDING_VIDEO_REVIEWS_GIFS_BILLING_CODE = 'video_reviews_gifs';

// Keep aligned with ecommerce-service WebsiteService.VIDEO_REVIEWS_GIFS_CREDITS.
export const ONBOARDING_VIDEO_REVIEWS_GIFS_CREDITS_PER_FUNNEL = 290;
export const ONBOARDING_VIDEO_REVIEWS_GIFS_GENERATED_COUNT = 4;

// Stable real UGC examples generated by Fluxi. Keep these as display samples, not selectable cards.
export const ONBOARDING_VIDEO_REVIEWS_GIFS_EXAMPLE_URLS = [
  'https://fluxi.s3.amazonaws.com/dev/assets/websites/329cb3676673470fb92c19e5af8cf78/video-reviews/video_review_avatar_1_1_76786df634.gif',
  'https://fluxi.s3.amazonaws.com/dev/assets/websites/6c934f16e0104f85ab4219e5aca6411/video-reviews/video_review_avatar_1_5_7a5956924c.gif',
  'https://fluxi.s3.amazonaws.com/dev/assets/websites/65b14bf060b84109915319e50fc0601/video-reviews/video_review_avatar_3_02e7e20ad3.gif',
  'https://fluxi.s3.amazonaws.com/dev/assets/websites/9d42e39ab9a64045889019e5aca63cd/video-reviews/video_review_avatar_4_4_d954762d06.gif',
] as const;
export const ONBOARDING_VIDEO_REVIEWS_GIFS_EXAMPLE_COUNT =
  ONBOARDING_VIDEO_REVIEWS_GIFS_EXAMPLE_URLS.length;

type VideoReviewsGifsFunnel = {
  includeVideoReviewsGifs?: boolean;
};

export const getOnboardingVideoReviewsGifsCredits = (funnels: VideoReviewsGifsFunnel[]) =>
  funnels.reduce(
    (total, funnel) =>
      total + (funnel.includeVideoReviewsGifs ? ONBOARDING_VIDEO_REVIEWS_GIFS_CREDITS_PER_FUNNEL : 0),
    0
  );
